module.exports = function(h, row) {
    if (_.isEmpty(row.outlets)) {
        return <i>{this.trans('product.visible_to_all_outlets')}</i>;
    }

    if (row.outlets.length === 1) {
        return row.outlets[0].name;
    }

    return (
        <i>
            Visible to {row.outlets.length}{' '}
            {this.trans('general.outlets').toLowerCase()}
        </i>
    );
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/payment/outlets.jsx